export default __webpack_public_path__ + "static/media/Mega_Sakoi.94885bba.jpg";